import { isFunction } from 'lodash-es';

import { useDynamicFormSchemaFieldDefinition } from '../dynamic/dynamicFormSchema';
import { useDynamicFormValidationRules } from '../dynamic/dynamicFormValidation';
import { getIsRequired } from '../formHelpers';

export function useRulesFromSchema({ schemaName, rules }) {
  const fieldDef = useDynamicFormSchemaFieldDefinition({ schemaName });
  const schemaRules = useDynamicFormValidationRules({
    schemaName,
    validation: fieldDef.validation,
  });

  let effectiveRules = rules;
  if (isFunction(rules)) {
    effectiveRules = rules(schemaRules);
  }
  if (!effectiveRules) {
    effectiveRules = schemaRules;
  }

  // If rules are provided, they take precedence over dynamic definition,
  // so this has to be extracted from them
  const isRequired = getIsRequired(effectiveRules);

  return { rules: effectiveRules, isRequired };
}
